module.exports = __webpack_public_path__ + "static/media/ger.502a2ad2.webp";